export default __webpack_public_path__ + "static/media/pszczola.af055816.svg";